import { HeaderView } from 'components/Header/Header.view';

export const Header = HeaderView;
